import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--menu-item-form"
export default class extends Controller {
  static targets = ["pageField", "urlField", "linkSettingsField"]
  static values = {
    linkType: String
  }

  connect() {
    this.linkTypeValue = this.linkTypeValue || "page"
    this.toggleFields()
  }

  changeType(event) {
    this.linkTypeValue = event.target.value
    this.toggleFields()
  }

  toggleFields() {
    const type = this.linkTypeValue
    this.toggleField(this.pageFieldTarget, type === "page")
    this.toggleField(this.urlFieldTarget, type === "external")
    this.toggleField(this.linkSettingsFieldTarget, type !== "heading")
  }

  toggleField(target, shouldShow) {
    if (!target) return

    target.classList.toggle("hidden", !shouldShow)

    target.querySelectorAll("input, select, textarea").forEach((element) => {
      element.disabled = !shouldShow
    })
  }
}
